import { map } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MenuButton from '../../components/menu-button';
import { navigateToSitePage } from '../../actions/navigate-to-site-page';
import { getMenuButtonSitePages, getCurrentSitePageId } from '../../selectors/site-pages-selectors';
import { getCurrentLocation } from '../../selectors/location-history-selectors';

const ROOT_PATH = '/';

class PageMenuButton extends Component {
  handleChange = event => this.props.navigateToSitePage(event.target.value);
  render() {
    const { sitePages, location } = this.props;
    const items = map(sitePages, ({ pageId, title }) => ({
      value: pageId,
      label: title,
    }));
    const buttonProps = {
      value: this.props.currentPageId,
      items,
      onChange: this.handleChange,
    };

    if (location.pathname !== ROOT_PATH) {
      buttonProps.navigateTo = ROOT_PATH;
    }

    return <MenuButton {...buttonProps}/>;
  }
}

PageMenuButton.propTypes = {
  sitePages: PropTypes.array,
  currentPageId: PropTypes.string,
  navigateToSitePage: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = state => ({
  sitePages: getMenuButtonSitePages(state),
  currentPageId: getCurrentSitePageId(state),
  location: getCurrentLocation(state),
});

const mapDispatchToProps = {
  navigateToSitePage,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageMenuButton);



// WEBPACK FOOTER //
// ./app/containers/page-menu-button/page-menu-button.js